import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import FeedbackBlock from "../components/FeedbackBlock/FeedbackBlock";
import FeedbackWithReply from "../components/FeedbackBlock/FeedbackWithReply";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";
import { Helmet } from "react-helmet";

const Reviews = () => {
  const { t } = useTranslation("pages");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>{t("reviews.meta.title")}</title>
      </Helmet>

      <Nav></Nav>
      <div className="sectionPage container">
        <div className={`sideP88 titleCont borderNo`}>
          <div className="titleBlock">
            <h1 id="brxeFemrai" className="top60">
              {t("reviews.heading")}
            </h1>
          </div>
        </div>
      </div>
      <FeedbackBlock></FeedbackBlock>
      <FeedbackWithReply></FeedbackWithReply>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default Reviews;
